import React from 'react'

import classes from './DelegateData.scss'

import CheckBox from '../../../../../UI/Forms/Checkbox/Checkbox'

import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { getDisplayDate } from '../../../../../../helpers/utils'
import moment from 'moment'

const delegateData = ({ data, deleteRowClicked, cancelDelegateChanged, dropdownOptions }) => {
  const getLabel = (key, value) => {
    if (key === 'to_emp_detail_id') {
      key = 'emp_id'
    }
    const dropdownKey = {
      company_id: 'companyOptions',
      emp_type_id: 'empTypeOptions',
      emp_id: 'empOptions',
      org_id: 'orgOptions',
      position_id: 'positionOptions',
      level_id: 'empLevelOptions'
    }
    const label = {
      emp_id: 'full_name',
      position_id: 'position_name'
    }
    let form = dropdownOptions[dropdownKey[key]]?.find(res => res[key] === +value)

    return form?.[label[key]]
  }
  let header = 0
  const rows = data.map((row, rowIndex) => {
    const rowData = Object.entries(row).map(rowData => {
      const [rowKey, rowAttrs] = rowData
      let dataDisplay = null
      if (['from_emp_detail_id', 'emp_delegate_id'].includes(rowKey)) {
        return null
      }
      if (rowAttrs.dataType === 'checkbox') {
        dataDisplay = (
          <CheckBox checked={!!rowAttrs.value} changed={e => cancelDelegateChanged(rowIndex, e)} />
        )
      } else if (rowAttrs.dataType === 'date') {
        dataDisplay = getDisplayDate(rowAttrs.value)
      } else {
        let value = rowAttrs.value
        if (rowKey !== 'seq_no') {
          value = getLabel(rowKey, rowAttrs.value)
        }

        dataDisplay = value
      }
      if (header === 0) {
        return (
          <div key={`${rowKey}-${rowIndex}`} className={classes.DataItem}>
            <div className={classes.Label}>{rowAttrs.label}</div>
            <div className={classes.Value}>{dataDisplay}</div>
          </div>
        )
      } else {
        return (
          <div key={`${rowKey}-${rowIndex}`} className={classes.DataItem}>
            {/* <div className={classes.Label}>{rowAttrs.label}</div> */}
            <div className={classes.Value}>{dataDisplay}</div>
          </div>
        )
      }
    })
    header = header + 1
    let checkDate = false
    if (
      moment(row.start_date?.value).isAfter(new Date()) ||
      moment(row.start_date?.value).isSame(new Date())
    ) {
      checkDate = true
    }
    return (
      <div key={rowIndex} className={classes.DataRow}>
        {rowData}
        <div className={classes.ButtonWrapper}>
          <IconButton
            disabled={!checkDate}
            color={'default'}
            onClick={() => deleteRowClicked(rowIndex)}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
    )
  })
  return (
    <div className={classes.DelegateDataWrapper}>
      <div className={classes.DelegateDataBox}>{rows}</div>
    </div>
  )
}

export default delegateData
